import React, { useContext, useMemo } from 'react';

// Mock Theme Context (Replace with actual theme context if available)
const ThemeContext = React.createContext({
  colors: { secondaryColor: '#ff0000' }
});

const AdsUnpaid = ({title}) => {
  const muiTheme = useContext(ThemeContext);

  const styles = useMemo(() => ({
    container: {
      padding: 20,
      background: '#fed5da',
      maxWidth: 700,
      fontSize:'18px'
    },
    link: {
      color: muiTheme.colors.secondaryColor,
      fontWeight: 700,
      textDecoration: 'underline',
    },
  }), [muiTheme]);

  return (
    <div  className='form_div' style={styles.container}>
      {title} is a premium feature that can be used in your application.
      Please contact us for pricing:{' '}
      <a
        href="mailto:support@radiofxinc.com"
        target="_blank"
        rel="noopener noreferrer"
        style={styles.link}
      >
        support@radiofxinc.com
      </a>
    </div>
  );
};

export default AdsUnpaid;
